import type { User } from "./types";

/** 兼容 guest_info / user_info 驼峰或下划线字段名 */
export function pickFirstRechargePromoRatio(
  user: User | null | undefined
): number | string | null | undefined {
  if (!user) return undefined;
  const u = user as unknown as Record<string, unknown>;
  return (
    (u.firstRechargeRulePromoRatio as number | string | null | undefined) ??
    (u.first_recharge_rule_promo_ratio as number | string | null | undefined)
  );
}

export function pickFirstRechargePopupShowPercent(
  user: User | null | undefined
): boolean | undefined {
  if (!user) return undefined;
  const u = user as unknown as Record<string, unknown>;
  const v =
    u.firstRechargePopupShowPercent ?? u.first_recharge_popup_show_percent;
  if (v === undefined || v === null) return undefined;
  if (typeof v === "boolean") return v;
  if (v === 1 || v === "1" || v === "true") return true;
  if (v === 0 || v === "0" || v === "false") return false;
  return undefined;
}
